import { alpha } from '@mui/material/styles';
import isHighContrastTheme from '%evp_theme/brandbook/appearance/isHighContrastTheme';

export default function brandSurfaceInk(theme, opacity) {
    const ink = theme.palette.brandSurface.contrastText;

    return isHighContrastTheme(theme) ? ink : alpha(ink, opacity);
}
